export const PAYMENT_SPEED = {
  INSTANT: 'Instant',
};

export const COLLECTION_DISTANCE = {
  ZERO: '0',
};

export const STATUSES = {
  FOR_SALE: 'for_sale',
  SOLD_AWAIT: 'sold_wait',
  UNDER_OFFER: 'under_offer',
  UNSOLD_BELOW_RESERVE_BID: 'unsold_below_reserve_bid',
};

export const VALID_STATUSES = Object.values(STATUSES);

export const DEALER_PB_IDS = [
  20405, 19399, 38442, 34715, 23077, 10205, 2347, 824, 985, 3651, 1498, 984,
  9162, 2772, 23644, 49844, 1044, 38216, 7356, 1534, 22124, 1909, 22928, 3834,
  9979, 6568, 29987, 1294, 14480, 24519, 613, 15926, 6660, 10124, 2360, 3674,
  1480, 4659, 8980, 5027, 3304, 34971, 17696, 5596, 38040, 43021, 6987, 15770,
  1011, 8963, 12638, 6405, 6477, 6298, 5123, 46172, 17015, 32229, 13586, 6628,
  14102, 757, 18648, 949, 35481, 17705, 6575, 9585, 10206, 740, 1375, 17357,
  213, 7373, 35813, 44203, 15779, 986, 9649, 15121, 9216, 6727, 343, 24322,
  11532, 27769, 22118, 26446, 3587, 1814, 12067, 24514, 1982, 1941, 30152,
  16664, 799, 22431, 8938, 21091, 24126, 17619, 987, 9169, 50856, 43278, 7176,
  15804, 11419, 24503, 91, 855, 8826, 15122, 31740, 37316, 49050, 15972, 35464,
  10239, 6549, 6508, 7263, 1300, 14873, 21181, 1063, 1304, 36678, 20754, 42848,
  38747, 6293, 8814, 1983, 42406, 8369, 2610, 23656, 16139, 6032, 1512, 8467,
  6908, 887, 24907, 31203, 5600, 11328, 2081, 384, 2268, 35300, 29337, 2755,
  9472, 429, 42943, 1659, 928, 21924, 28574, 4151, 37863, 17581, 14776, 914,
  17325, 45628, 12373, 9015, 15825, 10306, 23389, 12393, 15711, 24785, 15167, 22972,
  15131, 15749, 9173, 6655, 1383, 3498, 2767, 13362, 27517, 1905, 15164, 7874,
  9604, 6673, 12820, 10346, 1258, 7542, 12017, 48469, 20576, 22931, 1043, 16088,
  2855, 8281, 807, 11255, 22927, 14884, 18543, 13964, 21132, 17178, 30621, 7538,
  12164, 45712, 37672, 1002, 734, 3871, 2439, 19820, 24831, 6193, 5801, 771, 36920,
  1275, 5849, 7392, 8377, 8921, 9349, 7626, 8621, 11286, 24520, 7043, 7327, 8780,
  12594, 1184, 6452, 9238, 43219, 10207, 10188, 21974, 22936, 8388, 52862, 1633,
  11606, 15429, 6545, 18743, 25248, 154, 4436, 6015, 4212, 13766, 42596, 2477, 41916,
  10316, 11293, 1602, 8531, 14889, 3266, 38306, 8720, 14030, 1160, 1298, 4126, 3781,
  17297, 41103, 13688, 96, 19532, 577, 46260, 2349, 1684, 3617, 16778, 1582, 8074,
  18380, 6912, 39261, 174, 4423, 18790, 1887, 30422, 37321, 373, 8083, 8311, 22959,
  17498, 42602, 30061, 1140, 1121, 8303, 11483, 13565, 8732, 683, 18854, 9843, 3957,
  31805, 22935, 25906, 52044, 18775, 12346, 1431, 12018, 17088, 798, 14525, 616, 12388,
  2879, 17735, 17955, 22802, 2287, 6369, 1387, 18079, 14098, 8819, 4824, 118, 495,
  12394, 16994, 29481, 8939, 21087, 13027, 1413, 8090, 6136, 28579, 1484, 23301,
  41950, 22933, 1061, 7009, 1384, 9426, 12452, 8868, 33656, 10689, 9115, 6546, 21820,
  6610, 8879, 3751, 1791, 12499, 729, 2258, 6569, 1040, 85, 5748, 1279, 1120, 21897,
  8530, 35806, 1461, 145, 26985, 19993, 41924, 6562, 19534, 3466, 3432, 10291, 11922,
  18857, 780, 8977, 7205, 15530, 23259, 39749, 1239, 8385, 8337, 1895, 8004, 9641,
  2596, 31108, 20813, 15375, 37309, 11936, 1045, 11297, 42754, 1903, 9025, 17771,
  3249, 1453, 7341, 22121, 16221, 707, 21580, 6577, 3500, 6039, 11788, 5634, 43460,
  16658, 8051, 15537, 13327, 38093, 16795, 17494, 1483, 8896, 7893, 18074, 16368, 7620,
  7245, 7244, 16937, 9568, 22970, 15737, 1077, 28901, 8542, 10032, 13764, 15526, 3479,
  14624, 10058, 9645, 10886, 22070, 9640, 10589, 7166, 3215, 16735, 15742, 12805, 1466,
  24217, 22944, 21801, 12335, 11155, 9947, 9518, 1904, 5982, 980, 1376, 23253, 12760,
  10852, 2318, 25665, 9157, 6608, 12232, 1508, 10633, 17143, 18473, 1731, 10591, 17535,
  337, 5778, 8327, 13411, 7404, 7110, 11261, 6386, 3599, 9663, 44567, 9398, 3922,
  12368, 3901, 14523, 933, 25972, 12255, 7282, 19118, 35808, 7562, 15792, 18521,
  8082, 13953, 7363, 9666, 13530, 23164, 7911, 7111, 12034, 994, 1257, 656, 6337, 6607,
  31264, 13060, 15827, 13528, 18553, 31691, 12628, 24504, 24330, 3109, 13372, 16833,
  6314, 8828, 7397, 36431, 8532, 6836, 22062, 135, 4527, 1727, 4477, 7758, 35393, 18736,
  2731, 7669, 7394, 9970, 474, 611, 13789, 7432, 7906, 14611, 7472, 36430, 6559, 16826,
  10535, 3682, 3812, 17960, 10953, 2532, 6682, 8683, 3465, 16049, 7516, 17110, 6317, 93,
  1758, 23049, 1232, 6548, 14281, 5015, 29954, 12667, 8257, 28379, 9106, 7391, 3805,
  21451, 5747, 1942, 3450, 17857, 11527, 12375, 15715, 10143, 1709, 86, 7916, 10170,
  24642, 25262, 17547, 19661, 15210, 21783, 18220, 17593, 1491, 19579, 15884, 13529,
  3505, 1246, 14146, 3521, 6542, 41549, 30146, 8190, 12748, 17024, 3518, 4233, 6397,
  4161, 7028, 1721, 6281, 2720, 13793, 4692, 1261, 6806, 39803, 13473, 9619, 777, 6567,
  11932, 2745, 28942, 6492, 43205, 17804, 14558, 6578, 2339, 23031, 15075, 12276, 16561,
  9166, 8373, 28149, 17260, 8232, 7860, 13463, 9156, 43098, 2728, 29191, 9473, 31900,
  9942, 12595, 879, 32867, 16270, 8536, 5750, 35476, 28296, 175, 24448, 6400, 9659, 27863,
  10030, 41186, 20026, 30901, 9182, 21831, 2382, 7134, 7367, 22804, 14937, 6399, 1943,
  27766, 7843, 16568, 1296, 7513, 42597, 8045, 8238, 3941, 8299, 2624, 11889, 17029,
  14591, 11663, 17492, 14938, 6002, 11033, 30697, 8297, 12254, 36772, 13768, 16549, 19115,
  8810, 16656, 19498, 1516, 6695, 7211, 15806, 3588, 24271, 7499, 7559, 3261, 16759,
  18046, 6553, 875, 6656, 1028, 2002, 15925, 11802, 3547, 1328, 12753, 14842, 6860, 14241,
  16469, 10764, 1940, 41421, 9592, 15453, 6612, 6609, 9163, 35299, 17914, 5434, 8772,
  30451, 1165, 3499, 24449, 5028, 4964, 27678, 17854, 18248, 8298, 6547, 53245, 53244,
  52737, 54200, 9969, 23838, 47564, 36576, 36579, 9978, 36574, 36578, 52601, 38945,
  36577, 36575, 35461, 31106, 35462, 35469, 35466, 35463, 1803, 35468, 35465, 22969,
  12454, 23180, 7407, 11287, 10507, 5203, 6535, 9007, 5675, 8534, 16442, 1332, 51459,
  31149, 989, 43480, 6004, 18750, 9283, 8816, 30367, 18654, 10084, 51467, 1302, 8969, 684,
  51241, 7500, 7393, 18343, 7473, 658, 8354, 7938, 8599, 41862, 913, 42270, 31848, 17466,
  3628, 8002, 11294, 2681, 18518, 23307, 36941, 1393, 1948, 27800, 11524, 7697, 7792, 2395,
  19091, 7565, 38025, 7403, 44702, 27811, 8309, 1722, 10760, 1435, 30785, 1012, 8140, 11807,
  44292, 38742, 17531, 22968, 13804, 1322, 4543, 635, 24005, 7428, 18856, 23557, 687, 25565,
  9201, 30849, 471, 46272, 20411, 27124, 11874, 1622, 20853, 32889, 15240, 878, 23295, 8052,
  8010, 2237, 11923, 22408, 30334, 905, 38330, 7609, 11023, 2828, 7498, 39256, 39258, 9237,
  3660, 21059, 44291, 7691, 14915, 1359, 2525, 50164, 7466, 10319, 834, 51461, 12808, 43730,
  19531, 1654, 46178, 3618, 27959, 28781, 11867, 5415, 12399, 2631, 17191, 6827, 726, 17626,
  11702, 1090, 637, 1009, 27264, 30236, 17532, 19643, 1309, 11194, 688, 8901, 42852, 8565,
  997, 24568, 46124, 10580, 16434, 51466, 34639, 35822, 23636, 37881, 17485, 7695, 9123,
  1651, 5655, 38134, 49057, 19012, 32662, 27260, 41861, 26210, 37889, 15573, 16742, 20652,
  35460, 2076, 35510, 35467, 18851, 946, 3681, 16169, 23056, 37960, 9769, 8725, 9160, 7611,
  9811, 7923, 22419, 7759, 1360, 18520, 2638, 7862, 7234, 11774, 14911, 21455, 10820, 7436,
  1132, 7909, 12749, 37518, 16230, 7530, 9756, 11732, 7571, 39203, 41011, 43313, 25695, 20796,
  13467, 23739, 20076, 2601, 23791, 7222, 33209, 37362, 27032, 7455, 9541, 7564, 14285, 28441,
  6054, 11986, 26258, 17841, 22302, 17459, 27836, 41012, 36355, 3515, 23028, 827, 11502, 8096,
  3891, 1361, 7398, 5351, 18797, 37912, 14050, 15747, 9291, 9529, 6754, 16961, 39598, 17283,
  18219, 6677, 47923, 124, 16739, 17956, 17455, 5800, 13904, 39257, 30656, 14939, 49044, 14747,
  40662, 8600, 22934, 22300, 9588, 7569, 2496, 17359, 6653, 30187, 51457, 1081, 11485, 20793,
  17790, 7869, 29420, 15205, 7230, 7415, 23440, 10505, 3688, 7412, 9764, 14550, 20733, 10483,
  19711, 14167, 3621, 8301, 16550, 11870, 9389, 8856, 1022, 6558, 8208, 26040, 11319, 20106,
  25724, 16056, 6466, 12369, 6852, 10168, 39822, 40609, 17993, 20310, 9790, 1303, 18953, 9414,
  24990, 52431, 51462, 5468, 2083, 13122, 15885, 4385, 17296, 22540, 1515, 6402, 19828, 24864,
  31107, 20309, 17299, 22929, 22930, 16001, 1439, 7705, 11501, 12660, 14562, 51242, 21420,
  3956, 9504, 7994, 32258, 23686, 9428, 12367, 9161, 15651, 20074, 15957, 35030, 30113, 11856,
  8544, 7236, 4016, 22148, 42595, 43312, 35085, 23181, 7402, 5882, 920, 51456, 8047, 3590,
  13146, 8202, 9038, 1989, 51460, 1954, 18526, 9092, 4080, 20744, 3783, 962, 1993, 7226, 2368,
  8904, 24945, 4248, 40074, 23079, 17374, 5835, 7717, 836, 2251, 9290, 15147, 32417, 14483,
  8398, 1128, 9848, 6879, 6041, 22133, 7388, 7366, 16381, 12841, 9964, 7926, 8779, 8283,
  10753, 51465, 137, 8925, 16725, 1970, 24105, 23880, 4721, 5838, 28365, 6584, 29864, 7427,
  40030, 6043, 18171, 14736, 46743, 19502, 4391, 11586, 46264, 53242, 890, 16363, 4140, 1354,
  11216, 523, 17180, 15365, 17117, 1124, 5481, 14616, 6649, 14199, 41010, 1728, 9355, 17332,
  23565, 18774, 975, 1329,
];
